import { render } from "./SchedaProgetto.vue?vue&type=template&id=6b66bada&scoped=true"
import script from "./SchedaProgetto.vue?vue&type=script&lang=js"
export * from "./SchedaProgetto.vue?vue&type=script&lang=js"

import "./SchedaProgetto.vue?vue&type=style&index=0&id=6b66bada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b66bada"]])

export default __exports__